import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import {
  LayoutDashboard,
  Users,
  FileCheck,
  CreditCard,
  Settings,
  LogOut,
  Shield,
  ShoppingCart,
  UserCog,
  Package,
  TrendingUp
} from 'lucide-react';

const AdminSidebar: React.FC = () => {
  const { user, logout } = useAuth();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const closeSidebar = () => setSidebarOpen(false);

  const navItems = [
    { icon: <LayoutDashboard size={20} />, label: 'Overview', path: '/admin' },
    { icon: <Users size={20} />, label: 'User Management', path: '/admin/users' },
    { icon: <FileCheck size={20} />, label: 'Refund Reviews', path: '/admin/refunds' },
    { icon: <ShoppingCart size={20} />, label: 'Smart Orders', path: '/admin/procurement' },
    { icon: <Package size={20} />, label: 'Product Inventory', path: '/admin/products' },
    { icon: <TrendingUp size={20} />, label: 'Trend Briefing', path: '/admin/trend-briefing' },
    { icon: <CreditCard size={20} />, label: 'Payments', path: '/admin/payments' },
    { icon: <Settings size={20} />, label: 'System Settings', path: '/admin/settings' },
    { icon: <UserCog size={20} />, label: 'Normal User Mode', path: '/dashboard' },
  ];

  return (
    <>
      <button
        className={`sidebar-hamburger ${sidebarOpen ? 'open' : ''}`}
        onClick={() => setSidebarOpen(!sidebarOpen)}
        aria-label="Toggle sidebar"
      >
        <span className="hamburger-line" />
        <span className="hamburger-line" />
        <span className="hamburger-line" />
      </button>

      {sidebarOpen && (
        <div className="sidebar-overlay show" onClick={closeSidebar} />
      )}

      <div className={`sidebar ${sidebarOpen ? 'open' : ''}`} style={{ borderRight: '1px solid #FEE2E2', background: '#FFFBFB' }}>
        <NavLink to="/admin" className="sidebar-logo" onClick={closeSidebar} style={{ color: '#DC2626', display: 'flex', alignItems: 'center', gap: '8px' }}>
          <Shield size={24} /> Admin
        </NavLink>

        <nav className="sidebar-nav">
          {navItems.map((item) => (
            <NavLink 
              key={item.path} 
              to={item.path} 
              className={({ isActive }) => `sidebar-item ${isActive ? 'active' : ''}`}
              style={({ isActive }) => isActive ? { background: '#FEF2F2', color: '#DC2626' } : {}}
              onClick={closeSidebar}
            >
              {item.icon}
              <span>{item.label}</span>
            </NavLink>
          ))}
        </nav>

        <div className="sidebar-footer">
          <div className="user-profile-mini">
            <div className="user-avatar" style={{ background: '#FEE2E2', color: '#DC2626' }}>
              {user?.full_name ? user.full_name : 'Admin'}
            </div>
            <div className="user-info-mini">
              <div className="user-email-mini">{user?.email}</div>
            </div>
            <button 
              onClick={logout} 
              className="btn-outline" 
              style={{ padding: '8px', minHeight: 'auto' }}
              title="Logout"
            >
              <LogOut size={16} />
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default AdminSidebar;
